import { ProcessDefinition } from './processdefinition';
import { AssigneeInfo } from './complete-response';


/**
 * 提交审批操作返回结果
 */
export class ExcutionResponse {
    constructor() { }

    /**
     * 流程实例ID
     */
    procInstId: string;

    /**
     * dataId
     */
    dataId: string;

    /**
     * 指定参与者信息：需要指定参与者的活动、待指定用户列表
     */
    nextAssigneeInfos: AssigneeInfo[];
    
    /**
     * 需要交互
     */
    needInteraction: boolean;
    
    /**
     * 下一节点信息
     */
    nextFlowNodes: FlowNodeInfo[];

    /**
     * 流程定义列表：多个符合条件的流程定义需要手工选择
     */
    procDefs: ProcessDefinition[];
}

export class FlowNodeInfo {

    activityDefinitionId: string;

    activityDefinitionName: string;

    selectedAssignees: User[];

    assigneeInfo: AssigneeInfo;

}

export class User {

    id: string;

    name: string;
    
}
